
$(document).ready(function () {

 
    $(".faq-list li h3").click( function (){
    	$(this).next('div').fadeToggle();
    	$(this).toggleClass("active");
    	$(this).parent().siblings().find('div').hide();
    	$(this).parent().siblings().find('h3').removeClass("active");
	});
    $('#filter').click(function(){
		$(".listing-lft").addClass("open");
    });
	$('#filter-close').click(function(){
        $(".listing-lft").removeClass("open");
	});
});